import { Logo } from "@/components/Brand";

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="relative hidden overflow-hidden bg-tm-dark lg:block">
      <img src="/images/team.jpg" alt="Tax professionals meeting" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-t from-tm-dark via-tm-dark/70 to-tm-dark/30" />
      <div className="relative flex h-full flex-col justify-between p-12 text-white">
        <Logo dark />
        <div>
          <p className="tm-eyebrow !text-tm-gold">For CA · CS · Tax professionals</p>
          <h2 className="mt-4 max-w-md font-display text-4xl font-extrabold leading-tight">Where India's tax experts and their clients meet.</h2>
          <p className="mt-4 max-w-md text-white/70">Grow your practice, share knowledge and find the right professional for every filing.</p>
        </div>
      </div>
    </div>
    <div className="flex items-center justify-center bg-tm-sand px-6 py-12">
      <div className="w-full max-w-md tm-fade-up">
        <div className="mb-8 lg:hidden"><Logo /></div>
        <h1 className="font-display text-3xl font-extrabold text-tm-green">{title}</h1>
        <p className="mt-2 text-slate-600">{subtitle}</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);
